<template>
  <div :id="id" class="modal fade">
    <div class="modal-dialog modal-md">
      <div class="modal-content">
        <div class="row modal-header">
          <h2 class="modal-title">
            Checks
            <!--<button @click="closeModal"><i class="fal fa-times"></i></button>-->
          </h2>
        </div>

        <div class="modal-body">
          <div>
            <span>Excel erfolgreich hochgeladen.</span>
          </div>
          
            <div v-if="json && json.checks.length > 0">Es wurden Unterschiede gefunden. Für eine Detailansicht laden Sie den Excelreport herunter.</div>
            <div v-if="json && json.checks.length == 0">Es wurden keine Unterschiede gefunden.</div>
          
          <div class="modal-footer text-center">
            <button type="button" class="btn btn-default" @click="closeModal">
              Cancel
            </button>
            <button type="button" class="btn btn-primary" @click="generateExcel">
              Download Excel
            </button>
            <button type="button" class="btn btn-primary" @click="transform">
              Build XML-File
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import "bootstrap/dist/js/bootstrap";
import { modal } from "../../mixins/Modal";
import Api from "@/Api"
import FileDownload from "js-file-download"
import page from "@/mixins/Page";


export default {
  name: "CheckModal",
  components: {
  },
  mixins: [modal, page],
  props: {
    id: {
      type: String,
      required: true,
      default: "check-modal",
    },
    color: {
      type: String,
      required: false,
      default: null,
    },
    eventName: {
      type: String,
      default: "",
    },
    json: {
      type: Object,
    },
  },
  data() {
    return {
      sortBy: "",
      sortDesc: false,
      excelFile: null,
      fields: [
        {
          key: "productNumber",
          sortable: true,
          label: "Produktnummer",
        },
      ],
      fieldsChecks: [
        {
          key: "productNumber",
          sortable: true,
          label: "Produktnummer",
        },
        {
          key: "LieferantenBezeichnungDE",
          sortable: true,
          label: "LieferantenBezeichnungDE",
          tdClass: (value) => {
            if (value && value.old != value.new) {
              return "text-danger";
            }
          },
          formatter: function (value) {
            if (value && value.old != value.new)
              return `Alt: ${value.old}` + "\n" + `Neu: ${value.new}`;
            else return "keine Unterschiede";
          },
        },
        {
          key: "descriptionFR",
          sortable: true,
          label: "descriptionFR",
          tdClass: (value) => {
            if (value && value.old != value.new) {
              return "text-danger";
            }
          },
          formatter: function (value) {
            if (value && value.old != value.new)
              return `Alt: ${value.old}` + "\n" + `Neu: ${value.new}`;
            else return "keine Unterschiede";
          },
        },
        {
          key: "descriptionDE",
          sortable: true,
          label: "descriptionDE",
          tdClass: (value) => {
            if (value && value.old != value.new) {
              return "text-danger";
            }
          },
          formatter: function (value) {
            if (value && value.old != value.new)
              return `Alt: ${value.old}` + "\n" + `Neu: ${value.new}`;
            else return "keine Unterschiede";
          },
        },
        {
          key: "descriptionIT",
          sortable: true,
          label: "descriptionIT",
          tdClass: (value) => {
            if (value && value.old != value.new) {
              return "text-danger";
            }
          },
          formatter: function (value) {
            if (value && value.old != value.new)
              return `Alt: ${value.old}` + "\n" + `Neu: ${value.new}`;
            else return "keine Unterschiede";
          },
        },
        {
          key: "lagermenge",
          sortable: true,
          label: "lagermenge",
          tdClass: (value) => {
            if (value && value.old != value.new) {
              return "text-danger";
            }
          },
          formatter: function (value) {
            if (value && value.old != value.new)
              return `Alt: ${value.old}` + "\n" + `Neu: ${value.new}`;
            else return "keine Unterschiede";
          },
        },
        {
          key: "lieferfristSoll",
          sortable: true,
          label: "lieferfristSoll",
          tdClass: (value) => {
            if (value && value.old != value.new) {
              return "text-danger";
            }
          },
          formatter: function (value) {
            if (value && value.old != value.new)
              return `Alt: ${value.old}` + "\n" + `Neu: ${value.new}`;
            else return "keine Unterschiede";
          },
        },
        {
          key: "subsequentDeliveryOrReorderPeriod",
          sortable: true,
          label: "subsequentDeliveryOrReorderPeriod",
          tdClass: (value) => {
            if (value && value.old != value.new) {
              return "text-danger";
            }
          },
          formatter: function (value) {
            if (value && value.old != value.new)
              return `Alt: ${value.old}` + "\n" + `Neu: ${value.new}`;
            else return "keine Unterschiede";
          },
        },
      ],

      fieldsSelectedEqs: [{ key: "equity", sortable: true, label: "Selected" }],
      showList: true,
      selectedEquitiesAlertModal: [],
      notSelectedEquitiesAlertModal: [],
    };
  },
  computed: {
    icon: function () {
      if (this.color) {
        if (this.color === "success") return "fa-check-circle-o";
        if (this.color === "warning") return "fa-warning";
        if (this.color === "danger") return "fa-times-circle-o";
      }
      return null;
    },
    textColor: function () {
      if (this.color) return `text-${this.color}`;
      return null;
    },
    permissions() {
      return this.$store.state.permissions;
    },
    statistiken() {
      return this.$store.state.belegstatistik;
    },
    selectedEquities() {
      return this.$store.state.selectedEquities;
    },
  },
  created() {},
  methods: {
    openModal() {
      this.shown = true;
      $("#" + this.id).modal("show");
    },
    closeModal() {
      this.shown = false;
      $("#" + this.id).modal("hide");
    },
    back() {
      this.showList = true;
    },
    generateExcel(){
      Api.post(
        "/excel-download/", this.json,
        { responseType: "blob" } //SWE: notwendig damit OutputExcel nicht beschädigt wird
      )
        .then((response) => {
          this.excelFile = new Blob([response.data], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          });
          FileDownload(
            this.excelFile,
            `Report-${new Date().toLocaleDateString()}.xlsx`
          );
          this.loading = false;
        })
        .catch(() => {
          setTimeout(() => {
            this.$notify({
              type: "error",
              title: this.$t("notification.actionfailed"),
              text: this.$t("notification.errorwhilecreatingtheexcelfile"),
              duration: 7000,
            });
          }, 2000);
          this.loading = false;
        });
    },
    transform() {
      this.closeModal();
      this.$parent.transform(this.selectedEquitiesAlertModal);
    },
    apply() {
      this.showList = false;

      this.selectedEquitiesAlertModal = [];
      this.notSelectedEquitiesAlertModal = [];

      //this.notSelectedEquitiesAlertModal = Array.from(this.listings[0]);

      let selectedEquities = Array.from(new Set(this.selectedEquities));

      console.log(
        "equties unselected initally: " + this.notSelectedEquitiesAlertModal
      );
      console.log("selectedEquities: " + selectedEquities);

      selectedEquities.forEach((element) => {
        console.log("element: " + element);

        let equity = this.notSelectedEquitiesAlertModal.filter((obj) => {
          return obj.row_index === element;
        });

        console.log("equity: " + equity);

        this.selectedEquitiesAlertModal.push(equity[0]);

        const index = this.notSelectedEquitiesAlertModal.indexOf(equity[0]);

        console.log("index: " + index);
        if (index > -1) {
          this.notSelectedEquitiesAlertModal.splice(index, 1);
        }
      });

      console.log(
        "equities unselected after selection: " +
          this.notSelectedEquitiesAlertModal
      );
    },
  },
};
</script>

<style>
#calculate-modal .modal-content {
  margin: 5% auto 2% auto;
  box-shadow: 0px 3px 15px rgba(0, 0, 0, 0.3);
  background: #8f98ae;
  border-radius: 7px;
}
#calculate-modal .modal-header {
  background: #c5cbdc;
  height: 125px;
  border-radius: 7px 7px 0 0;
  display: flex;
  flex-flow: column;
  padding-top: 29px;
  padding-left: 47px;
  position: relative;
  z-index: 5;
  align-items: normal;
  box-shadow: 0px 5px 12px -1px rgba(0, 0, 0, 0.15);
  margin-left: 0;
  margin-right: 0;
  border: none;
}
#calculate-modal .modal-header {
  padding: 15px 0 0 75px;
}
#calculate-modal .modal-header h2 {
  margin-bottom: 2px;
  color: #8f98ae;
  font-weight: 700;
  font-size: 27px;
}
#calculate-modal .modal-header p {
  font-weight: 500;
  text-shadow: 1px 2px 2px rgba(0, 0, 0, 0.1);
  font-size: 19px;
  color: #213056;
}
#calculate-modal .modal-header span {
  color: white;
  float: right;
  padding-right: 20px;
  margin-top: -17px;
  cursor: pointer;
}
#calculate-modal .modal-body {
  padding-top: 0;
}
#calculate-modal .modal-footer {
  border: none;
  font-weight: 500;
  font-size: 14px;
  color: white;
}
#calculate-modal .modal-footer > div:first-child {
  background: #c5cbdc;
  width: 10vw;
  border-radius: 3px;
  padding: 5px;
  margin-right: auto;
  cursor: pointer;
}
#calculate-modal .modal-footer > div:nth-child(2) {
  background: #c5cbdc;
  width: 10vw;
  border-radius: 3px;
  padding: 5px;
  cursor: pointer;
}
#calculate-modal .modal-footer > div:nth-child(3) {
  background: #213056;
  width: 10vw;
  border-radius: 3px;
  padding: 5px;
  cursor: pointer;
}
#calculate-modal .modal-footer > div:nth-child(4) {
  background: #213056;
  width: 10vw;
  border-radius: 3px;
  padding: 5px;
  cursor: pointer;
}
#calculate-modal .equitiesBestaetigen {
  background: white;
  height: 60vh;
  overflow-y: scroll;
  scrollbar-color: #8f98ae #c5cbdc;
  scrollbar-width: thin;
}
#calculate-modal #equitiesWaehlen .row {
  margin-left: -0.98rem;
}
#calculate-modal .equitiesBestaetigen th {
  border-top: none;
}
</style>